import React from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'
import Button from '../../common/Button'
import { useIntl } from 'react-intl'

const EditMappings = ({ selectedDtcs, sid, enableMapping, filters }) => {
  const navigate = useNavigate()
  const intl = useIntl()

  const goToPosts = () => {
    navigate({
      pathname: `/vehicles/${sid}/dtcs/listing/mappings`,
      search: `?${createSearchParams({ dtc_id: selectedDtcs.map((dtc) => dtc.id) })}`,
    })
  }

  return (
    <Button
      className="multiline-button"
      disabled={selectedDtcs.length < 1 || !enableMapping ? true : false}
      testId="dtc-edit-mappings"
      onClick={(e) =>
        selectedDtcs.length < 1 ? e.preventDefault() : goToPosts()
      }
    >
      {intl.formatMessage({ id: 'dtcs.mappings.editMappingsFor' }, { count: selectedDtcs.length })}
    </Button>
  )
}

EditMappings.propTypes = {}

export default EditMappings
